import React from "react";

function DenunciaQRInfo() {
  const email = "buzontomasclandestinas@caasim.gob.mx";
  const subject = "Reporte de toma clandestina / robo de agua";

  const body = `Municipio:

Localidad:

Colonia:

Calle:

Número:

Referencias específicas:

Comentarios adicionales:

(No olvides adjuntar tus fotografías)
`;

  const mailtoHref = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title text-uppercase">
          INFORMACIÓN PARA DENUNCIA DE TOMA CLANDESTINA
        </h3>
        <hr className="hr-gob" />
      </div>

      <div>
        <h4 className="title">Procedimiento</h4>
        <p className="mb-4">
          Para reportar un robo de agua o una toma clandestina, es necesario
          tener a la mano los siguientes datos: <b>municipio, localidad, colonia,
          calle, número, referencias específicas, fotografías y un espacio para
          comentarios adicionales.</b> Esta información debe enviarse al correo{" "}
          <b><a href={mailtoHref}>{email}</a></b>, donde se dará seguimiento al reporte
          y se brindará atención al denunciante.
        </p>
      </div>

      {/* <div className="text-center mt-4">
        <a
          href={mailtoHref}
          className="btn btn-primary"
          aria-label="Clic aquí para denunciar tomas clandestinas"
          title="Clic aquí para denunciar tomas clandestinas"
        >
          Clic aquí para denunciar tomas clandestinas
        </a>
      </div> */}
    </div>
  );
}

export default DenunciaQRInfo;
